import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface X2ExperiencesModel extends BaseModel {
  variables?: { [key: string]: string } | X2ExperiencesVariables;
}

export interface X2ExperiencesVariables {
  X2ExpParagraph: string;
  X2Exp1Image: string;
  X2Exp2Image: string;
  X2Exp1ImageHref: string;
  X2Exp2ImageHref: string;
  X2Exp1ImageAlt: string;
  X2Exp2ImageAlt: string;
  X2Exp1Description: string;
  X2Exp2Description: string;
  X2Exp1Heading: string;
  X2Exp2Heading: string;
  X2Exp1CtaLink: string;
  X2Exp2CtaLink: string;
  X2Exp1CtaText: string;
  X2Exp2CtaText: string;
  X2Exp1ImageHrefSegmentRegex: string;
  X2Exp2ImageHrefSegmentRegex: string;
  X2Exp1CtaLinkSegmentRegex: string;
  X2Exp2CtaLinkSegmentRegex: string;
}

export class X2ExperiencesInitVariables implements X2ExperiencesVariables {
  X2ExpParagraph = '';
  X2Exp1Image = '';
  X2Exp2Image = '';
  X2Exp1ImageHref = '';
  X2Exp2ImageHref = '';
  X2Exp1ImageAlt = '';
  X2Exp2ImageAlt = '';
  X2Exp1Description = '';
  X2Exp2Description = '';
  X2Exp1Heading = '';
  X2Exp2Heading = '';
  X2Exp1CtaLink = '';
  X2Exp2CtaLink = '';
  X2Exp1CtaText = '';
  X2Exp2CtaText = '';
  X2Exp1ImageHrefSegmentRegex = '';
  X2Exp2ImageHrefSegmentRegex = '';
  X2Exp1CtaLinkSegmentRegex = '';
  X2Exp2CtaLinkSegmentRegex = '';
}

export class X2ExperiencesInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new X2ExperiencesInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
